import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles((theme: any) => ({
  root: { display: 'flex', justifyContent: 'center' },
  progressBar: {
    maxWidth: 600,
    minWidth: 200,
    width: '100%',
    margin: theme.spacing(2),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    height: theme.spacing(1),
    borderRadius: theme.spacing(1),
    display: 'inline-block',
    backgroundColor: theme.palette.brand.cream,
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.brand.greenLight,
    },
  },
}));

interface Props {
  progressPercent: number;
}

//TODO: need to add to storybook
export default function ProgressLine({ progressPercent = 0 }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress
        className={classes.progressBar}
        variant="determinate"
        value={progressPercent}
      />
    </div>
  );
}
